<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :style="iconSizeStyle(size)"
    viewBox="0 0 10 11"
    fill="none"
    aria-hidden="true"
    class="g-icon-trash"
  >
    <path
      d="M8 3.00004H2V8.10014C2 8.52833 2.00017 8.81946 2.01855 9.04448C2.03646 9.26368 2.06904 9.37594 2.10889 9.45414C2.20475 9.64227 2.35777 9.79529 2.5459 9.89116C2.6241 9.931 2.73636 9.96358 2.95557 9.98149C3.18059 9.99987 3.47171 10 3.8999 10H6.1001C6.52829 10 6.81941 9.99987 7.04443 9.98149C7.26364 9.96358 7.3759 9.931 7.4541 9.89116C7.64223 9.79529 7.79525 9.64227 7.89111 9.45414C7.93096 9.37594 7.96354 9.26368 7.98145 9.04448C7.99983 8.81946 8 8.52833 8 8.10014V3.00004ZM5.73486 4.80815C5.93013 4.61288 6.24663 4.61288 6.44189 4.80815C6.63716 5.00341 6.63716 5.31992 6.44189 5.51518L5.70703 6.25004L6.44189 6.98491C6.63716 7.18017 6.63716 7.49667 6.44189 7.69194C6.24663 7.8872 5.93013 7.8872 5.73486 7.69194L5 6.95707L4.26514 7.69194C4.06987 7.8872 3.75337 7.8872 3.55811 7.69194C3.36284 7.49667 3.36284 7.18017 3.55811 6.98491L4.29297 6.25004L3.55811 5.51518C3.36284 5.31992 3.36284 5.00341 3.55811 4.80815C3.75337 4.61288 4.06987 4.61288 4.26514 4.80815L5 5.54301L5.73486 4.80815ZM5 1.00004C4.50283 1.00004 4.35235 1.00444 4.24121 1.03422C3.89612 1.12669 3.62665 1.39616 3.53418 1.74125C3.51827 1.80065 3.50996 1.87127 3.50537 2.00004H6.49463C6.49004 1.87127 6.48173 1.80065 6.46582 1.74125C6.37335 1.39616 6.10388 1.12669 5.75879 1.03422C5.64765 1.00444 5.49717 1.00004 5 1.00004ZM9 8.10014C9 8.51188 9.00051 8.85083 8.97803 9.12602C8.95506 9.40705 8.90586 9.66559 8.78223 9.90825C8.59049 10.2845 8.28446 10.5905 7.9082 10.7823C7.66555 10.9059 7.407 10.9551 7.12598 10.9781C6.85079 11.0006 6.51184 11 6.1001 11H3.8999C3.48816 11 3.14921 11.0006 2.87402 10.9781C2.593 10.9551 2.33445 10.9059 2.0918 10.7823C1.71554 10.5905 1.40951 10.2845 1.21777 9.90825C1.09414 9.66559 1.04494 9.40705 1.02197 9.12602C0.999489 8.85083 1 8.51188 1 8.10014V3.00004H0.5C0.223858 3.00004 1.28851e-07 2.77618 0 2.50004C0 2.2239 0.223858 2.00004 0.5 2.00004H2.50537C2.51184 1.80416 2.52717 1.63619 2.56836 1.48246C2.75329 0.79228 3.29224 0.253335 3.98242 0.0684013C4.25278 -0.00404079 4.56721 4.18489e-05 5 4.19085e-05C5.43279 4.19383e-05 5.74722 -0.00404081 6.01758 0.0684013C6.70776 0.253336 7.24671 0.792279 7.43164 1.48246C7.47283 1.63619 7.48816 1.80416 7.49463 2.00004H9.5C9.77614 2.00004 10 2.2239 10 2.50004C10 2.77618 9.77614 3.00004 9.5 3.00004H9V8.10014Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
import { iconSizeStyle } from '~/utils/iconSize'

withDefaults(defineProps<{ size?: number | string }>(), {
  size: 12
})
</script>

<style scoped>
.g-icon-trash {
  display: block;
  flex-shrink: 0;
  color: inherit;
}
</style>
